import axios from "axios";
import apiConfig from "../config/apiConfig";
const serialize = (obj) => {
	if(JSON.stringify(obj) === JSON.stringify({})) return ''
	let str = ["?"];
	for (let p in obj)
		if (obj.hasOwnProperty(p)) {
			str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
		}
	return str.join("&");
}
const BASE_URL = apiConfig.BASE_URL

const makeRequest = (method,params = {},query={},baseDomain = BASE_URL,options={})=>{
	if(baseDomain === '') baseDomain = BASE_URL;
	const DATA_URL = baseDomain + 'api/panel/data' + serialize(query)
	return axios.post(DATA_URL,{
		method,
		params
	},options)
}
export const makeFormDataRequest = (url,formData,query={},baseDomain = BASE_URL,options={})=>{
	if(baseDomain === '') baseDomain = BASE_URL;
	const DATA_URL = BASE_URL + 'api/' + url + serialize(query)
	return axios.post(DATA_URL,formData,options)
}

export default makeRequest;
